<template>
  <!-- 案件详情-用户信息-沟通信息 -->
  <div v-if="!pageLock" class="communicate-info-block">
    <template v-if="checkPermission('用户信息栏-审核问题:查看', permList)">
      <!-- 审核问题-抗癌案件（2021年6月新增） -->
      <div
        v-if="
          allQuestionData && allQuestionData.length && isCaseType === 'cancer'
        "
        class="audit-issue-block"
      >
        <div v-for="(item, index) in reviewProblemData" :key="index">
          <p class="bold">{{ item.title }}</p>
          <ul class="issue-content">
            <li
              v-for="(iItem, iIndex) in item.issue"
              :key="iIndex"
              class="list-block"
            >
              <p class="title">{{ iIndex + 1 }}) {{ iItem.questionDesc }}</p>
              <el-select
                v-model="iItem.selectedId"
                placeholder="请选择"
                class="select-block"
                @change="(value) => onChangeIssueData(value, index, iIndex)"
              >
                <el-option
                  v-for="(oItem, oIndex) in iItem.options"
                  :key="oIndex"
                  :label="oItem.optionDesc"
                  :value="oItem.optionCode"
                />
              </el-select>
            </li>
          </ul>
        </div>
      </div>

      <!-- 审核问题-意外案件 -->
      <div v-if="isCaseType === 'accident'" class="audit-issue-block">
        <p class="bold">审核问题</p>

        <ul class="issue-content">
          <li
            v-for="(item, index) in reviewQuestionTitle[isCaseType]"
            :key="index"
            class="list-block"
          >
            <p class="title">{{ index + 1 }}) {{ item.title }}</p>
            <el-input
              v-model="infoData.reviewQuestion[item.key]"
              type="textarea"
              class="textarea-block"
              maxlength="200"
              show-word-limit
              placeholder="请输入内容"
              :rows="2"
            />
          </li>
        </ul>
      </div>
    </template>

    <!-- 渠道信息 -->
    <el-card
      v-if="checkPermission('用户信息栏-渠道信息:查看', permList)"
      class="card-block channel-block"
    >
      <div slot="header" class="clearfix">
        <span class="bold">渠道信息</span>
      </div>
      <div class="channel-content">
        <ul class="content-block flex">
          <li class="list-block flex">
            <p class="title">公司类型</p>
            <el-select
              v-model="infoData.companyType"
              placeholder="请选择公司类型"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allSelect.companyTypeEnums"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </li>
          <li class="list-block flex">
            <p class="title">从事行业</p>
            <div class="flex right-block">
              <el-select
                v-model="infoData.profession"
                placeholder="请选择从事行业"
                class="select-block min-input-block"
              >
                <el-option
                  v-for="(item, index) in allSelect.professionEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <el-input
                v-model="infoData.otherProfession"
                placeholder="请输入其他从事行业"
                class="min-input-block"
              />
            </div>
          </li>
          <li class="list-block flex">
            <p class="title">公司名称</p>
            <el-input
              v-model="infoData.companyName"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">公司规模</p>
            <el-input
              v-model="infoData.companySize"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">所在岗位</p>
            <el-select
              v-model="infoData.jobPosition"
              placeholder="请选择所在岗位"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allSelect.jobPositionEnums"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </li>
          <li class="list-block flex">
            <p class="title">岗位描述</p>
            <el-input
              v-model="infoData.positionDetail"
              placeholder="请输入内容"
              class="input-block"
            />
          </li>
          <li class="list-block flex">
            <p class="title">重要标记</p>
            <div class="flex right-block">
              <el-select
                v-model="infoData.importantCustomerMark"
                placeholder="请选择"
                class="select-block min-input-block"
              >
                <el-option
                  v-for="(item, index) in allSelect.importantCustomerEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <el-input
                v-model="infoData.importantCustomerDetail"
                placeholder="请输入其他从事行业"
                class="min-input-block"
              />
            </div>
          </li>
        </ul>
      </div>
    </el-card>

    <!-- 品牌信息 -->
    <el-card
      v-if="
        checkPermission('用户信息栏-品牌信息:查看', permList) ||
          checkPermission('用户信息栏-家庭成员背景情况:查看', permList)
      "
      class="card-block brand-block"
    >
      <div slot="header" class="clearfix">
        <span class="bold">品牌信息</span>
        <el-button
          v-if="
            isCaseType === 'cancer' &&
              checkPermission('用户信息栏-品牌信息:查看', permList)
          "
          class="btn-block"
          :disabled="isCaseArchive"
          @click="opExportUserLabel"
        >
          导出用户标签
        </el-button>
      </div>
      <div class="brand-content">
        <ul
          v-if="checkPermission('用户信息栏-品牌信息:查看', permList)"
          class="content-block flex"
        >
          <li class="list-block flex">
            <p class="title">生存情况</p>
            <el-select
              v-model="infoData.memberAliveStatus"
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allMemberAliveStatusType"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </li>
          <!-- 抗癌互助案件 -->
          <li v-if="isCaseType === 'cancer'" class="list-block flex">
            <p class="title max-title">主要治疗方式</p>
            <!-- 多选 -->
            <el-select
              v-model="infoData.currentTreatment"
              multiple
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allProjectData"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </li>
          <!-- 意外互助案件 -->
          <li v-if="isCaseType === 'accident'" class="list-block flex">
            <p class="title">治疗情况</p>
            <!-- 多选 -->
            <el-select
              v-model="infoData.currentTreatment"
              multiple
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allProjectDataYW"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </li>
          <li class="list-block flex">
            <p class="title">治疗花费</p>
            <el-select
              v-model="infoData.treatCost"
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allTreatCostType"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </li>
          <li class="list-block flex">
            <p class="title">治疗费来源</p>
            <!-- 多选 -->
            <el-select
              v-model="infoData.treatmentFeeSource"
              multiple
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allTreatmentFeeSource"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </li>
          <li class="list-block flex">
            <p class="title">配合程度</p>
            <el-select
              v-model="infoData.cooperateDegree"
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allCooperateDegree"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </li>
          <li
            v-if="allSelect.visitWillingnessEnums.length"
            class="list-block flex"
          >
            <p class="title">探访意愿</p>
            <el-select
              v-model="infoData.visitWillingness"
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allSelect.visitWillingnessEnums"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </li>
          <li class="list-block flex">
            <p class="title">表达能力</p>
            <el-select
              v-model="infoData.expressionAbility"
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in allExpressionAbility"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </li>
          <li class="list-block flex">
            <p class="title" style="white-space: nowrap; margin-right: 10px;">
              是否有特殊情况
            </p>
            <div class="flex right-block">
              <el-select
                v-model="infoData.hasSpecialCase"
                placeholder="请选择"
                class="select-block min-input-block"
              >
                <el-option
                  v-for="(item, index) in specialCircumstancesList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
              <el-input
                v-model="infoData.specialCase"
                placeholder="请输入内容"
                class="min-input-block"
              />
            </div>
          </li>
          <li class="list-block flex">
            <p class="title">案件类型</p>
            <el-select
              v-model="infoData.caseType"
              placeholder="请选择"
              class="select-block"
            >
              <el-option
                v-for="(item, index) in caseTypeList"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </li>
          <template v-if="isCaseType === 'cancer'">
            <li v-if="allSlowDiseaseSituation.length" class="list-block flex">
              <p class="title">慢病情况</p>
              <el-select
                v-model="infoData.ncsSituation"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(item, index) in allSlowDiseaseSituation"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </li>
            <li class="list-block flex">
              <p class="title">治疗情况</p>
              <el-select
                v-model="infoData.treatmentSituation"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(item, index) in allTreatment"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </li>
            <li class="list-block flex">
              <p class="title">患病人保险</p>
              <el-select
                v-model="infoData.patientInsurance"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(item, index) in allSickPersonInsurance"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </li>
            <li class="list-block flex">
              <p class="title">治疗阶段</p>
              <el-select
                v-model="infoData.treatmentStatus"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(item, index) in allTreatmentStage"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </li>
            <li class="list-block flex">
              <p class="title">营养品</p>
              <el-select
                v-model="infoData.nourishment"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(item, index) in allNutrition"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </li>
            <li class="list-block flex">
              <p class="title">购药情况</p>
              <el-select
                v-model="infoData.buyMedicineSituation"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(item, index) in allPurchaseOfDrug"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </li>
            <li class="list-block flex">
              <p class="title">用户活跃度</p>
              <el-select
                v-model="infoData.activityOfCustomer"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(item, index) in allCustomerActivity"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </li>

            <li class="list-block flex">
              <p class="title">平台认可度</p>
              <el-select
                v-model="infoData.approvalOfPlatform"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(item, index) in allPlatformRecognition"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </li>
          </template>
        </ul>

        <!-- 家庭成员情况 -->
        <div
          v-if="checkPermission('用户信息栏-家庭成员背景情况:查看', permList)"
          class="family-block"
        >
          <p class="title-block bold">家庭成员背景情况</p>
          <ul
            v-for="(item, index) in familyInfo"
            :key="index"
            class="content-block flex"
          >
            <li class="list-block flex">
              <p class="title">家庭成员</p>
              <el-select
                v-model="item.familyMember"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(relationItem, relationIndex) in allRelationEnums"
                  :key="relationIndex"
                  :label="relationItem.name"
                  :value="relationItem.code"
                />
              </el-select>
            </li>
            <li class="list-block flex">
              <p class="title max-title">特殊行业标记</p>
              <el-select
                v-model="item.specialJobMark"
                placeholder="请选择"
                class="select-block"
              >
                <el-option
                  v-for="(specialItem, specialIndex) in allSelect.specialJobMarkEnums"
                  :key="specialIndex"
                  :label="specialItem.name"
                  :value="specialItem.code"
                />
              </el-select>
            </li>
            <li class="list-block flex">
              <p class="title">姓名</p>
              <el-input
                v-model="item.name"
                placeholder="请输入内容"
                class="input-block"
              />
            </li>
            <li class="list-block flex">
              <p class="title">电话号码</p>
              <el-input
                v-model="item.phoneNumber"
                placeholder="请输入内容"
                class="input-block"
                maxlength="11"
              />
            </li>
            <li class="list-block flex">
              <p class="title">工作单位</p>
              <el-input
                v-model="item.employer"
                placeholder="请输入内容"
                class="input-block"
              />
            </li>
            <li class="list-block flex">
              <p class="title">职务</p>
              <el-input
                v-model="item.position"
                placeholder="请输入内容"
                class="input-block"
              />
            </li>
            <li class="list-block">
              <!-- 增加按钮 -->
              <el-button
                v-if="
                  index == familyInfo.length - 1 &&
                    familyInfo.length < familyInfoMaxNum
                "
                type="primary"
                icon="el-icon-plus"
                circle
                size="mini"
                class="icon-btn"
                :disabled="isCaseArchive"
                @click="addFamilyInfo"
              />
              <!-- 移除按钮 -->
              <el-button
                v-else
                type="danger"
                icon="el-icon-minus"
                circle
                size="mini"
                class="icon-btn"
                :disabled="isCaseArchive"
                @click="reduceFamilyInfo(index)"
              />
            </li>
          </ul>
        </div>

        <ul
          v-if="checkPermission('用户信息栏-品牌信息:查看', permList)"
          class="textarea-list"
        >
          <li class="list-block flex">
            <p class="title mr10">治疗特殊性</p>
            <el-input
              v-model="infoData.treatmentSpec"
              type="textarea"
              class="textarea-block"
              placeholder="请输入内容"
              maxlength="200"
              show-word-limit
              :rows="2"
            />
          </li>
          <li class="list-block flex">
            <p class="title mr10">家庭特殊性</p>
            <el-input
              v-model="infoData.familySpec"
              type="textarea"
              class="textarea-block"
              placeholder="请输入内容"
              maxlength="200"
              show-word-limit
              :rows="2"
            />
          </li>
          <li class="list-block flex">
            <p class="title mr10">职业特殊性</p>
            <el-input
              v-model="infoData.jobSpec"
              type="textarea"
              class="textarea-block"
              placeholder="请输入内容"
              maxlength="200"
              show-word-limit
              :rows="2"
            />
          </li>
          <li class="list-block flex">
            <p class="title mr10">沟通过程中的特殊性</p>
            <el-input
              v-model="infoData.communicateSpecFeel"
              type="textarea"
              class="textarea-block"
              placeholder="请输入内容"
              maxlength="200"
              show-word-limit
              :rows="2"
            />
          </li>
        </ul>
      </div>
    </el-card>

    <!-- 保存 -->
    <div class="button-block">
      <el-button
        type="primary"
        icon="el-icon-upload"
        class="btn-block"
        :disabled="
          !checkPermission('审核工作栏-审核问题:保存', permList) ||
            isCaseArchive
        "
        @click="onSubmit"
      >
        保存
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CommunicateInfo",

  data() {
    return {
      pageLock: true,
      // 所有选择的选项数据
      allSelect: {
        professionEnums: [], // 从事行业
        jobPositionEnums: [], // 所在岗位
        companyTypeEnums: [], // 公司类型
        importantCustomerEnums: [], // 重要标记
        visitWillingnessEnums: [], // 探访意愿
        specialJobMarkEnums: [], // 特殊行业标记
      },

      // 沟通信息
      infoData: {
        ncsSituation: null, // 慢病情况(2021年6月新增)
        patientInsurance: null, // 患病人保险(2021年6月新增)
        treatmentStatus: null, // 治疗阶段(2021年6月新增)
        treatmentSituation: null, // 治疗情况(2021年6月新增)
        nourishment: null, // 营养品(2021年6月新增)
        buyMedicineSituation: null, // 购药情况(2021年6月新增)
        approvalOfPlatform: null, // 对平台认可度(2021年6月新增)
        activityOfCustomer: null, // 客户活跃度(2021年6月新增)
        // 审核问题信息
        reviewQuestion: {
          diseaseInfo: "",
          firstDiscomfort: "",
          discomfortConfirmed: "",
          medicalExamination: "",
          treatmentLocation: "",
          treatmentInfo: "",
          insuranceInfo: "",
          knowChannel: "",
          jobInfo: "",
          accidentInfo: "",
          accidentDetail: "",
          familyInfo: "",
          bodyInfo: "",
          accidentCertificate: "",
          autopsyInfo: "",
          accidentJobInfo: "",
          healthInfo: "",
        },
      },

      // 家庭成员背景情况
      familyInfoMaxNum: 5, // 家庭成员最多的人数
      familyInfo: [],

      // 审核问题（2021-06新增）
      allQuestionData: [], // 所有审核问题数组
      reviewProblemData: [
        {
          title: "审核问题类型1-病情阶段",
          issue: [],
        },
        {
          title: "审核问题类型2-会员支付能力",
          issue: [],
        },
      ],
      newReviewQuestion: [], // 选中的问题数组
      // 审核问题
      reviewQuestionTitle: {
        // 意外
        accident: [
          {
            key: "accidentInfo",
            title: "请问会员发生意外是什么时候？在哪里？",
          },
          {
            key: "accidentDetail",
            title:
              "麻烦您简单说一下意外的经过(详细记录意外的经过，包括的内容但不限：如何发现的，发现是谁，导致事故的原因，见证人是谁，跟进人是谁，是否有拨打120）",
          },
          {
            key: "familyInfo",
            title: "家属是什么时候知道事故发生的？当时是否有送院抢救？",
          },
          {
            key: "bodyInfo",
            title: "遗体是否已火化/土葬/仍在殡仪馆？",
          },
          {
            key: "accidentCertificate",
            title:
              "公安部门是否有提供意外事故证明？/交警大队是否出具了事故认定书？",
          },
          {
            key: "autopsyInfo",
            title:
              "【除了交通事故、高坠、溺水、火灾等的其他身故要提醒】是否有做尸检？如果不能明确身故原因，请向公安部门确认是否需要尸检。",
          },
          {
            key: "accidentJobInfo",
            title: "请问会员生前从事什么职业？发生事故是在工作过程中吗？",
          },
          {
            key: "healthInfo",
            title:
              "会员平时身体怎么样？（近期是否有就医、是否长期服药等疾病情况，基本适用如无故摔倒致死等无法确定死因的会员）",
          },
        ],
      },

      // 配合程度
      allCooperateDegree: [
        { name: "请选择", code: 1 },
        { name: "配合意愿高，愿意拍摄视频并且宣传", code: 2 },
        { name: "配合意愿一般，可以接受站内的真实性展示(探访等)", code: 3 },
        { name: "配合意愿低，需要多次沟通后才接受配合", code: 4 },
      ],
      // 表达能力
      allExpressionAbility: [
        { name: "请选择", code: 1 },
        { name: "表达能力强，说话清晰，能清楚表达个人情况及治疗情况", code: 2 },
        { name: "表达能力一般，有当地口音，能表达个人情况", code: 3 },
        { name: "表达能力弱，需要人协助才能表达清楚", code: 4 },
      ],
      // 治疗花费
      allTreatCostType: [
        { name: "请选择", code: 1 },
        { name: "5w以下", code: 2 },
        { name: "5w~10w", code: 3 },
        { name: "10w~20w", code: 4 },
        { name: "20w~50w", code: 5 },
        { name: "50w以上", code: 6 },
      ],
      // 主要治疗方式（抗癌）
      allProjectData: [
        { name: "手术", id: 1 },
        { name: "化疗", id: 2 },
        { name: "放疗", id: 3 },
        { name: "靶向", id: 4 },
        { name: "姑息", id: 5 },
        { name: "免疫", id: 6 },
        { name: "中医", id: 7 },
        { name: "无治疗", id: 8 },
        // { name: '保守治疗', id: 5 }
      ],
      // 治疗情况（意外）
      allProjectDataYW: [
        { name: "手术", id: 1 },
        { name: "化疗", id: 2 },
        { name: "放疗", id: 3 },
        { name: "靶向", id: 4 },
        { name: "保守治疗", id: 5 },
      ],
      // 治疗费用来源
      allTreatmentFeeSource: [
        { name: "积蓄", id: 1 },
        { name: "借款", id: 2 },
        { name: "医保及商业保险", id: 3 },
        { name: "放弃治疗", id: 4 },
      ],
      // 生存情况
      allMemberAliveStatusType: [
        { name: "请选择", code: 1 },
        { name: "健在", code: 2 },
        { name: "已故", code: 3 },
      ],
      // 家庭成员背景情况-家庭成员关系
      allRelationEnums: [
        { name: "配偶", code: 1 },
        { name: "父母", code: 2 },
        { name: "子女", code: 3 },
        { name: "兄弟姐妹", code: 4 },
        { name: "其他亲属", code: 5 },
      ],
      // 慢病情况（2021-06新增）
      allSlowDiseaseSituation: [
        { name: "是", code: 1 },
        { name: "否", code: 0 },
      ],
      // 治疗情况（2021-06新增）
      allTreatment: [
        { name: "波动中但变差", code: 1 },
        { name: "波动中但整体趋好", code: 2 },
        { name: "恶化", code: 3 },
        { name: "复发转移", code: 4 },
        { name: "稳定", code: 5 },
      ],
      // 患病人保险（2021-06新增）
      allSickPersonInsurance: [
        { name: "有，已经理赔", code: 1 },
        { name: "有，正在理赔", code: 2 },
        { name: "有，没有理赔", code: 3 },
        { name: "无", code: 4 },
      ],
      // 治疗阶段（2021-06新增）
      allTreatmentStage: [
        { name: "确诊3个月内", code: 1 },
        { name: "治疗术后0~3个月内", code: 2 },
        { name: "治疗术后3个月~1年", code: 3 },
        { name: "治疗术后1年~3年", code: 4 },
        { name: "治疗术后3年以上", code: 5 },
        { name: "死亡", code: 6 },
      ],
      // 营养品（2021-06新增）
      allNutrition: [{ name: "有", code: 1 }, { name: "无", code: 0 }],
      // 购药情况（2021-06新增）
      allPurchaseOfDrug: [
        { name: "无外购药", code: 1 },
        { name: "部分外购药", code: 2 },
        { name: "除处方外，主动尝试外购药", code: 3 },
        { name: "完全停药", code: 4 },
      ],
      // 对平台认可度（2021-06新增）
      allPlatformRecognition: [
        { name: "一般认可", code: 1 },
        { name: "只想互助别人不谈", code: 2 },
        { name: "有负面情绪", code: 3 },
      ],
      // 用户活跃度（2021-06新增）
      allCustomerActivity: [
        { name: "很爱交流", code: 1 },
        { name: "有问有答，不问不答", code: 2 },
        { name: "不愿交流", code: 3 },
      ],
      // 是否有特殊情况（2023-04新增）
      specialCircumstancesList: [
        { name: "是", code: 1 },
        { name: "否", code: 0 },
      ],
      // 案件类型（2023-04新增）
      caseTypeList: [
        { name: "申诉案件", code: 1 },
        { name: "客诉案件", code: 2 },
        { name: "诉讼案件", code: 3 },
      ],
    };
  },

  // 计算属性
  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList,
    }),

    /**
     * 判断案件类型（抗癌、意外）
     */
    isCaseType() {
      const { productName } = this.caseInfo;
      return productName && productName.substring(0, 2) === "抗癌" ? 'cancer' : 'accident';
    },

    // 判断当前案件是否为“归档”流程
    isCaseArchive() {
      return this.caseInfo.flowCode >= 103500;
    },
  },

  // 侦听器
  watch: {
    /**
     * 监听案件详情数据的变化
     */
    caseInfo(val, oldVal) {
      const { allSelect } = this;
      const { caseCode } = val;
      const { caseCode: oldCaseCode } = oldVal;

      if (caseCode !== oldCaseCode) {
        if (allSelect && !allSelect.professionEnums.length) {
          this.fetchAllSelect();
        }
        this.fetchInfoData();
        this.pageLock = false;
      }
    },
  },

  mounted() {
    const {
      caseInfo: { caseCode },
    } = this;
    if (caseCode) {
      this.fetchAllSelect();
      this.fetchInfoData();
      this.pageLock = false;
    }
  },

  methods: {
    /**
     * 补充资料-页面所需要枚举
     */
    async fetchAllSelect() {
      const _this = this;

      try {
        const { data: result } = await _this.axios.get(
          `/case-info/information-supplement/enums/list`
        );
        if (result && result.status === "000000") {
          _this.allSelect = result.data;
        } else {
          _this.$alert(result && result.message, "提示");
        }
      } catch (error) {
        console.log("补充资料-页面所需要枚举-请求失败", error);
      }
    },

    /**
     * 获取沟通信息
     */
    async fetchInfoData() {
      const _this = this;
      const {
        caseInfo: { caseCode },
      } = _this;

      try {
        const { data: result } = await _this.axios.get(
          `/communicate/info/${caseCode}`
        );

        if (result && result.status === "000000") {
          const newResult = result && result.data;
          if (newResult) {
            // 如果当前案件没有审核问题的相关字段，则保存默认值
            if (!newResult.reviewQuestion) {
              const { infoData } = _this;
              newResult.reviewQuestion = infoData.reviewQuestion;
            }

            // 判断家庭成员信息是否存在
            if (newResult.familyRecord && newResult.familyRecord.length) {
              const { familyRecord } = newResult;
              _this.familyInfo = familyRecord;
            } else {
              // 初始化家庭成员信息数据
              _this.familyInfo = [_this._initFamilyInfoData()];
            }

            // 当沟通补充资料为空的时候
            // caseCode有可能返回null，需要重新赋值
            if (!newResult.caseCode) {
              newResult.caseCode = caseCode;
            }
            // version版本号返回null的时候，需要重新赋值
            if (!newResult.version) {
              newResult.version = 0;
            }
            // 赋值新版审核问题的选中答案数据
            if (
              newResult.newReviewQuestion &&
              newResult.newReviewQuestion.length
            ) {
              _this.newReviewQuestion = newResult.newReviewQuestion;
            }
            _this.infoData = newResult;

            if (_this.isCaseType === "cancer") _this.fetchQuestionData();
          }
        } else {
          _this.$alert(result && result.message, "提示");
        }
      } catch (error) {
        console.log("获取沟通信息-请求失败", error);
      }
    },

    /**
     * 获取新版审核问题
     */
    async fetchQuestionData() {
      const _this = this;
      const { allQuestionData } = _this;

      if (allQuestionData.length) {
        _this.finishingIssueData();
      } else {
        try {
          const { data: result } = await _this.axios("/question/");
          if (result && result.status === "000000") {
            const allQuestionData = result && result.data;

            _this.allQuestionData = allQuestionData;
            _this.finishingIssueData();
          } else {
            _this.$alert(result && result.message, "提示");
          }
        } catch (error) {
          console.log("获取新版审核问题-请求失败", error);
        }
      }
    },

    /**
     * 整理审核问题的数据（展示数据和选中的数据）
     */
    finishingIssueData() {
      const { allQuestionData, newReviewQuestion } = this;
      const { productId } = this.caseInfo;
      const newReviewProblemData = [
        { title: "审核问题类型1-病情阶段", issue: [] },
        { title: "审核问题类型2-会员支付能力", issue: [] },
      ];

      // 重新遍历审核问题数据
      allQuestionData &&
        allQuestionData.forEach((item) => {
          // 针对其中的个别问题根据当前计划类型，判断是否加入显示
          if (
            productId !== "000000000101001" &&
            item.questionCode === "10011"
          ) {
            // 中青年抗癌计划的问题
            return;
          } else if (
            productId !== "000000000101005" &&
            item.questionCode === "10012"
          ) {
            // 老年抗癌计划的问题
            return;
          } else {
            // 在审核问题的列表数据中，标记出选中的数据
            newReviewQuestion &&
              newReviewQuestion.forEach((zItem) => {
                if (zItem.questionCode === item.questionCode) {
                  item &&
                    item.options &&
                    item.options.forEach((oItem) => {
                      if (oItem.optionCode === zItem.optionCode) {
                        item.selectedId = oItem.optionCode;
                      }
                    });
                }
              });

            if (item.type === 1) {
              newReviewProblemData[0].issue.push(item);
            } else if (item.type === 2) {
              newReviewProblemData[1].issue.push(item);
            }
          }
        });

      this.reviewProblemData = JSON.parse(JSON.stringify(newReviewProblemData));
    },

    /**
     * 增加家庭成员背景信息
     */
    addFamilyInfo() {
      const { familyInfo, familyInfoMaxNum } = this;

      if ((familyInfo, length < familyInfoMaxNum)) {
        familyInfo.push(this._initFamilyInfoData());
        this.familyInfo = familyInfo;
      }
    },

    /**
     * 删除家庭成员背景信息
     * @param {string} index 下标值
     */
    reduceFamilyInfo(index) {
      const { familyInfo } = this;
      familyInfo.splice(index, 1);

      this.familyInfo = JSON.parse(JSON.stringify(familyInfo));
    },

    /**
     * 导出用户标签
     */
    opExportUserLabel() {
      const _this = this;
      const homePath = _this.homePath();
      const {
        caseInfo: { caseCode },
      } = _this;

      const url = `${homePath}/communicate/info/exportReviewQuestion?caseCode=${caseCode}&_t=${new Date().valueOf()}`;
      window.location.href = url;
    },

    /**
     * 监听审核问题的选中事件
     */
    onChangeIssueData(optionCode, index, iIndex) {
      const { reviewProblemData, newReviewQuestion } = this;
      const issueData = reviewProblemData[index].issue[iIndex]; // 当前审核问题的全部数据
      const { questionCode, options } = issueData; // 获取问题code和问题选项数据
      let tagDesc = ""; // 当前问题标签
      // 判断在“已被选中审核问题的答案数组”中是否存在当前问题选项
      let sign = false; // 是否存在的标记
      let signIndex = 0; // 对应下标值

      // 遍历选项数据，获取被选中答案的“tagDesc”值
      options &&
        options.forEach((item) => {
          if (item.optionCode === optionCode) tagDesc = item.tagDesc;
        });

      // 遍历已被选中审核问题的答案数组，获取其中是否与当前修改的审核问题对应的数据
      newReviewQuestion &&
        newReviewQuestion.forEach((item, index) => {
          if (item.questionCode === questionCode) {
            sign = true;
            signIndex = index;
          }
        });

      // 最后判断，如果在“newReviewQuestion”数组中查找不到对应的问题答案，则在数组中新增，反之替换问题的答案
      if (!sign) {
        newReviewQuestion.push({ questionCode, optionCode, tagDesc });
      } else {
        newReviewQuestion[signIndex].optionCode = optionCode;
        newReviewQuestion[signIndex].tagDesc = tagDesc;
      }

      this.newReviewQuestion = JSON.parse(JSON.stringify(newReviewQuestion));
    },

    /**
     * 保存按钮点击事件-更新沟通信息
     */
    async onSubmit() {
      const _this = this;
      const { familyInfo, infoData, newReviewQuestion } = _this;

      // 家庭成员信息
      if (familyInfo && familyInfo.length) {
        infoData.familyInfo = familyInfo;
      }

      // 审核问题(2021年6月新增)
      if (newReviewQuestion && newReviewQuestion.length) {
        infoData.newReviewQuestions = newReviewQuestion;
      }

      try {
        const { data: result } = await _this.axios.put(
          `/communicate/info/modify`,
          infoData
        );
        if (result && result.status === "000000") {
          _this.fetchInfoData();
          _this.$emit("updateCaseOperationList"); // 通知父级组件-更新历史操作记录
        }
        _this.$alert("保存成功", "提示");
      } catch (error) {
        console.log("更新沟通信息-请求失败", error);
      }
    },

    /**
     * 返回默认家庭成员数据
     */
    _initFamilyInfoData() {
      return {
        familyMember: "",
        specialJobMark: "",
        name: "",
        phoneNumber: "",
        employer: "",
        position: "",
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
